import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { SportsListing, SportsListingService, game, SportBetPanelService, ConfigService, Market, Selection, Event, MarketStatus, EventStatus, selection, SportsHomeService} from 'baseline-lib';
import { WebviewpagesPage } from '../../shared/webviewpages/webviewpages';
import {ModalController, NavController } from 'ionic-angular';
import { SportsFullDetailPage } from '../sports-full-detail/sports-full-detail';
import { Global } from '../../../global/global';
import { CustomToast } from '../../shared/services/custom-toast';
import { TranslateService } from '@ngx-translate/core';


/**
 * Generated class for the SportsListingComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sports-listing',
  templateUrl: 'sports-listing.html'
})
export class SportsListingComponent {
  @Output() onclickeventlisting: EventEmitter<any> = new EventEmitter<any>();

  @Input() position: number;
  @Input() gameObj: game;  
  @Input() searchText: string;  
  @Input() eventUrl: string;
  SportsListingObj : SportsListing;
  httplink:string;
  _marketStatus = MarketStatus;
  _eventStatus = EventStatus;
  selected_game_id:number = 0;
  selected_league_id : number = 0
  current_expanded_event:number =0
  dataObj : number[] = [];

  constructor(public _sportsListingService : SportsListingService, public _sportBetServices: SportBetPanelService, public globalData: Global,
    public toast: CustomToast, public translate : TranslateService,
    public _configService : ConfigService, public modalCtrl : ModalController, public navCtrl: NavController, public _sportsHomeService : SportsHomeService) {

    console.log('Hello SportsListingComponent Component');
    
    this.SportsListingObj = new SportsListing();
    if(this._sportsListingService.sportsListingObj.selections)
      this.SportsListingObj.selections = this._sportsListingService.sportsListingObj.selections;
      
      console.log("SportsListingObjSelections is", this.SportsListingObj.selections)
    this.eventUrl = '';

  }

  ngOnInit(){
    
    this._sportBetServices._removeBetPanel.subscribe(data => {
      this._sportsListingService.removePanel(data, this.SportsListingObj)
    });
    //this._sportsHomeService.getGamesByGameType();
  }

  ngOnChanges(changes: SimpleChanges) {
    
    console.log("Position is", changes.position)
    if (changes.gameObj) {
       var _game = changes.gameObj.currentValue as game;
      this._sportBetServices.selectedGame = _game;
      
        /*below if condition is commented because when bet is added 
        in bet panel and navigating to and back from sports detail page 
        than leagues are not constructed */
     // if(!this._sportsListingService.sportsListingObj.selections || this._sportsListingService.sportsListingObj.selections.length == 0)
      this._sportsListingService.constructListing(_game, this.SportsListingObj);
      this.SportsListingObj.game=_game;
      console.log("SportsListingObjGame is", this.SportsListingObj.game)
      if(changes.position.currentValue ==0)
      {
        this.selected_league_id = this.SportsListingObj.game.leagues[0].leagueid
        this.selected_game_id = this.SportsListingObj.game.gameid
      }     
      else
      {
        this.selected_league_id = this.SportsListingObj.game.leagues[0].leagueid
      }
    }
  }

  navigateStats(_eventno: number) {
    this.httplink = this._configService.getMatchStatsURL().concat(_eventno);
    let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
    profileModal.present();
  }

  BetSelection(_selection: Selection, _market: Market, _event: Event) {
    this.globalData.isBetAdded = true;
    _event.inplay = this.globalData.inPlay;

    this._sportsListingService.BetSelection(_selection, _market, _event);
    
    if(this._sportBetServices.isMaxPanelCount){
      this.translate.get('Maximum limit reached').subscribe(
                  value => 
                  {
                    this.toast.showError(value);
                  });
              
    }
  }

  LoadSportsFullDetail(eventid){
    this.dataObj[0] = this._sportBetServices.selectedGame.gameid;
    this.dataObj[1] = eventid;
    this.onclickeventlisting.emit(this.dataObj);
    // this.navCtrl.push(SportsFullDetailPage,{id:this._sportBetServices.selectedGame.gameid, event_id:eventid});
  }

  getSelectedGameId(gameid)
  {
    if(this.selected_game_id == gameid)
    {
      this.selected_game_id = 0;
    }
    else
    {
      this.selected_game_id = gameid;
      console.log("Game id is",this.selected_game_id);
    }
  }

  getSelectedLeagueId(leagueid)
  {
    if(this.selected_league_id == leagueid)
    {
      this.selected_league_id = 0;
    }
    else
    {
      this.selected_league_id = leagueid
      console.log("League Id is ", this.selected_league_id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sports/sports-listing/sports-listing.ts